import axios from 'axios';
import { API_URL, handleApiError } from '../utils/config';

/**
 * Fetch global site metadata
 * @returns {Promise<Object>} Global site metadata
 */
export const fetchSiteMetadata = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo/site-metadata`);
    return response.data;
  } catch (error) {
    
    // Return null instead of throwing to prevent blocking the app
    return null;
  }
};

/**
 * Generate Open Graph image URL
 * @param {string} imagePath - Relative image path
 * @returns {string} Full image URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  // Check if image path is already a full URL
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  // Always append .webp to the filename
  const imageFileName = `${imagePath}.webp`; // Always use .webp
  // Use Google Cloud Storage path
  return `https://storage.googleapis.com/eladore-ruffles.appspot.com/images/full/${imageFileName}`;
};
/**
 * Create meta description from HTML content
 * @param {string} htmlContent - HTML content to extract text from
 * @param {number} maxLength - Maximum length of description
 * @returns {string} Plain text description
 */
export const createMetaDescription = (htmlContent, maxLength = 160) => {
  if (!htmlContent) return '';
  // Strip HTML tags
  const tempElement = document.createElement('div');
  tempElement.innerHTML = htmlContent;
  const plainText = tempElement.textContent || tempElement.innerText || '';
  // Truncate to maxLength
  const truncated = plainText.substring(0, maxLength).trim();
  return truncated + (plainText.length > maxLength ? '...' : '');
};

export default {
  fetchSiteMetadata,
  getImageUrl,
  createMetaDescription
};
